/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import jwtDecode from "jwt-decode";
import { showToastError } from "~/components";
import { useAuth0 } from "~/components/Auth/auth";
import { LOCAL_STORAGE } from "~/constants/localStorage";

type MyToken = {
  exp: number;
};

export const handleSessionExpired = () => {
  if (!localStorage.getItem(LOCAL_STORAGE.refreshingToken)) {
    showToastError(
      "Your session has expired. The page will be reloaded automatically.",
      2000,
      undefined,
      () => {
        localStorage.removeItem(LOCAL_STORAGE.refreshingToken);
        window.location.reload();
      }
    );
  }
  localStorage.setItem(LOCAL_STORAGE.refreshingToken, "true");
};

const useRefreshToken = () => {
  const { logout } = useAuth0();

  const refreshToken = () => {
    try {
      const token = localStorage.getItem(LOCAL_STORAGE.token);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const decodedToken = jwtDecode<MyToken>(token!);
      if (decodedToken.exp - 30 < Math.floor(Date.now() / 1000)) {
        handleSessionExpired();
      }
    } catch (e) {
      if (!localStorage.getItem(LOCAL_STORAGE.refreshingToken)) {
        showToastError("Something gone wrong!", 2000, undefined, () => {
          localStorage.removeItem(LOCAL_STORAGE.refreshingToken);
          logout({ returnTo: window.location.origin });
        });
      }
      localStorage.setItem(LOCAL_STORAGE.refreshingToken, "true");
    }
  };

  return { refreshToken };
};

export { useRefreshToken };
